<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-05-13 20:04:40
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-06-01 14:30:38
 * @FilePath: /goldenSalesMobile/src/views/RefundOrder/Application/index.vue
 * @Description: 退款申请
-->
<template>
  <div class="page-container">
    <div class="order-info">
      <p>订单编号：{{ orderId }}</p>
      <p>付款时间：{{ createTime }}</p>
    </div>
    <div class="goods-list">
      <ul>
        <li v-for="(item, index) in goodsList" :key="index">
          <p>
            <span>{{ item.ProductShelfName }}</span>
            <span>￥{{ item.SettlePrice }}</span>
          </p>
          <div>
            <span>退款数量</span>
            <van-stepper
              integer
              :min="0"
              :max="item.RefundNum"
              :value="item.RefundNum"
              :name="item.ProductId"
              @change="onGoodsNumChange"
            />
          </div>
        </li>
      </ul>
    </div>
    <div class="refund-total">
      <div>
        <span>退款金额</span>
        <span>￥{{ refundMoney.toFixed(2) }}</span>
      </div>
      <p>退款金额将在1-7个工作日内原路径返回</p>
    </div>
    <div class="refund-reason">
      <van-radio-group v-model="reasonId" checked-color="#CCA567">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in reasonList"
            :key="index"
            :title="item.describe"
          >
            <template #right-icon>
              <van-radio
                :name="item.id"
                @click="onClickRefundReason(item.id)"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="fixed-btn">
      <van-button
        block
        :color="
          isVisable
            ? 'linear-gradient(to right, #FA9B00, #FBCA39)'
            : 'linear-gradient(to right, #B5BBD0, #D7DDEA)'
        "
        @click="onSubmit"
      >
        申请退款
      </van-button>
    </div>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/order";
import { submitRefund } from "@/api/refund";
import { arrayGroupBy } from "@/utils/index";

export default {
  data() {
    return {
      orderId: this.$route.params.id,
      createTime: "",
      goodsList: [],
      refundMoney: 0,
      reasonList: [
        {
          id: 0,
          describe: "其他",
        },
        {
          id: 1,
          describe: "时间/原因安排去不了",
        },
        {
          id: 2,
          describe: "天气原因不方便去",
        },
        {
          id: 3,
          describe: "有更便宜的票",
        },
      ],
      isVisable: true,
      reasonId: 0,
      reasonTxt: "其他",
    };
  },

  created() {
    this.init();
  },

  methods: {
    // 初始化：获取订单明细及退单商品列表
    init() {
      getOrderDetail({ query: { id: this.orderId } })
        .then((res) => {
          let data = res.Items[0];
          this.createTime = data.CreateTime;
          let details = data.Details;
          if (details instanceof Array && details.length > 0) {
            details.map((subItem) => {
              subItem.RefundNum = 0; // 初始化可退款数量
              // 按Ticket的状态遍历计算出可以退款的数量，未使用状态的票券才可以退款
              let sortedTickets = arrayGroupBy(
                subItem.Tickets,
                function (ticket) {
                  return [ticket.Status.Id];
                }
              );
              sortedTickets.map((sort) => {
                if (sort[0].Status.Id === 1) {
                  subItem.RefundNum = sort.length;
                }
              });
              this.refundMoney += subItem.RefundNum * subItem.SettlePrice;
            });
            this.goodsList = details;
          }
        })
        .catch((err) => {
          // console.log(`获取订单明细报错${err}`)
        });
    },

    // 监听商品数量变化
    onGoodsNumChange(val, detail) {
      let target = detail.name;
      this.refundMoney = 0;
      this.goodsList.map((item) => {
        if (item.ProductId === target) {
          item.RefundNum = val;
        }
        this.refundMoney += item.RefundNum * item.SettlePrice;
      });
    },

    // 选择退款原因
    onClickRefundReason(checkedId) {
      this.reasonList.map((item) => {
        if (item.id === checkedId) {
          this.reasonTxt = item.describe;
        }
      });
    },

    // 提交申请
    onSubmit() {
      let refundGoods = [];
      this.goodsList.map((item) => {
        refundGoods.push({ OrderDetailId: item.Id, Quantity: item.RefundNum });
      });
      let requestPrams = {
        OrderId: this.orderId,
        Reason: this.reasonTxt,
        Items: refundGoods,
      };

      submitRefund(requestPrams)
        .then((res) => {
          // console.log(res)
          this.$router.push({
            name: "Result",
            params: {
              type: "refund",
              status: "success",
              id: this.orderId,
            },
          });
        })
        .catch((err) => {
          // console.log(`退单报错${err}`)
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  .order-info {
    @include border-box(20px 40px);
    background: $blockBgColor;
    margin-bottom: 20px;

    > p {
      line-height: 1.5;
      font-size: 28px;
      color: $secondFontColor;
    }
  }

  .goods-list {
    margin-bottom: 20px;

    > ul {
      > li {
        @include border-box(20px 40px 10px);
        background: $blockBgColor;
        margin-bottom: 20px;

        > p {
          @include flex-box(space-between);
          line-height: 1.5;
          font-size: 28px;
          color: $secondFontColor;

          > span:first-child {
            margin-right: 100px;
          }
        }

        > div {
          @include flex-box(space-between);
          height: 100px;
          line-height: 1.5;
          font-size: 28px;
          color: $secondFontColor;

          &::v-deep .van-stepper {
            .van-stepper__input {
              margin: 0;
              width: 47px;
              background-color: #fff;
              border-top: 1px solid #d8d8d8;
              border-bottom: 1px solid #d8d8d8;
            }

            .van-stepper__minus,
            .van-stepper__plus {
              background-color: #fff;
              border: 1px solid #d8d8d8;
            }
          }
        }
      }
    }
  }

  .refund-total,
  .refund-reason {
    @include border-box(20px 40px);
    background: $blockBgColor;
    margin-bottom: 20px;
    border-top: 5px solid #fbca39;
  }

  .refund-total {
    > div {
      @include flex-box(space-between);
      line-height: 2;
      font-size: 28px;

      > span:first-child {
        color: $secondFontColor;
      }

      > span:last-child {
        color: $priceFontColor;
      }
    }

    > p {
      line-height: 1.5;
      font-size: 24px;
      color: #cca567;
    }
  }

  .refund-reason {
    margin-bottom: 150px;

    &::v-deep .van-hairline--top-bottom::after {
      border: none;
    }

    &::v-deep .van-cell {
      padding: 10px 0;
    }
  }
}
</style>
